import React, {useState, useEffect } from 'react';
import {    
            Button,
            Dialog,
            DialogActions,
            DialogTitle, 
            Grid,
            InputAdornment,
            LinearProgress,
            Switch,
            TextField
        } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { 
    CompassCalibration as CompassCalibrationIcon,
    Done as DoneIcon,
    Http as HttpIcon,
    Nature as NatureIcon,
    Person as PersonIcon,
    SettingsInputAntenna as SettingsInputAntennaIcon,
    VpnKey as VpnKeyIcon,
} from '@material-ui/icons';
import { SnackbarProvider, useSnackbar } from 'notistack';
import  FacebookCircularProgress  from '../Elementos/FacebookCircularProgress';
import { Autocomplete } from '@material-ui/lab';
import { v4 as uuidv4 } from 'uuid'; 
import { useAuth } from "../Auth";


const RegistrarEquipo = ({data, handleProcess, handleUpdate, dataZona, ModelosList, Marcas, Tipos})=>{
    const { enqueueSnackbar } = useSnackbar();
    const { authTokens } = useAuth(); 
    const [ isProcessing, setProcessing ] = useState(false);
    const [ openDialog, setOpenDialog ] = useState(false);
    const [ Datos, setDatos ] = useState({ 
        Marca:'', 
        Modelo:'', 
        Tipo:'', 
        IP:'192.168', 
        Usuario:'admin', 
        Password:'',
        isLocal:false,
        Frecuencia:'',
        SSID:'',
        KEY:'',
        Zona:'',
        Puerto:'',
        Comentario:''
    });
    const [ Modelos, setModelos ] = useState(ModelosList)
    const [ validacion1, setValidacion1 ] = useState(false);
    const [ isDisableTipo, setDisableTipo ] = useState(true);
    const [ isDisableModelo, setDisableModelo ] = useState(true);
    const [ isSelectedZona, setSelectedZona ] = useState(false);


    useEffect(()=>{
        if(validacion1){
            setValidacion1(false);
            enqueueSnackbar('Equipo Confirmado', {variant:'info'});
            setTimeout(()=>{
                handleSave();
            },1000);
        }
    },[validacion1]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleDatos = (e)=>{ setDatos({...Datos, [e.target.name]:e.target.value})};

    const handleValidacion1 = ()=>{
        setOpenDialog(false);
        if(Datos.Marca === ''){ enqueueSnackbar('Campo Marca Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.Tipo === ''){ enqueueSnackbar('Campo Tipo Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.Modelo === ''){ enqueueSnackbar('Campo Modelo Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.Zona === ''){ enqueueSnackbar('Campo Zona Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.IP === ''){enqueueSnackbar('Campo IP Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.Usuario === ''){ enqueueSnackbar('Campo Usuario Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.Password === ''){ enqueueSnackbar('Campo Password Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.Puerto === ''){ enqueueSnackbar('Campo Puerto Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.SSID === ''){ enqueueSnackbar('Campo SSID Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.KEY === ''){ enqueueSnackbar('Campo KEY Vacio' , {variant:'error'}); setProcessing(false);
        }else{   
            if(Datos.isLocal){
                switch(Datos.Tipo){
                    case 'AP':
                        if(Datos.Marca === 'MIKROTIK'){
                            fetch('api/mikrotik/ap/validar',{
                                method:'POST',
                                body: JSON.stringify(Datos),
                                headers:{
                                    'Content-Type': 'application/json'
                                }
                            }) 
                            .then(response=> response.json())
                            .then(result =>{
                                if(result.message){
                                    setValidacion1(true);                                  
                                }else{
                                    enqueueSnackbar(result.status, {variant:'error'});
                                    console.log(result);
                                    setProcessing(false);
                                }
                            });
                            break;
                        }else{
                            setValidacion1(true);
                            break;
                        }
                    case 'CPE':
                        if(Datos.Marca === 'MIKROTIK'){
                            fetch('api/mikrotik/ap/validar',{
                                method:'POST',
                                body: JSON.stringify(Datos),
                                headers:{
                                    'Content-Type': 'application/json'
                                }
                            }) 
                            .then(response=> response.json())
                            .then(result =>{
                                if(result.message){
                                    setValidacion1(true);                                  
                                }else{
                                    enqueueSnackbar(result.status.message === 'Timed out after 10 seconds' ? 'DIRECCION IP ERRONEA' : result.status.message , {variant:'error'});
                                    console.log(result);
                                    setProcessing(false);
                                }
                            });
                            break;
                        }else{
                            setValidacion1(true);
                            break;
                        }
                    default:
                        setValidacion1(true);
                        break;
                    
                }
            }else{
                setValidacion1(true);
            }
            
        }}}}}}}}}}
        
    };

    const handleSave = ()=>{
        const objeto = {...Datos};
        objeto.UsuarioCreate = authTokens.Usuario;
        objeto.uuid = uuidv4();
        fetch('api/equipos',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar('Equipo Guardado', {variant:'success'});
                setProcessing(false);
                handleProcess(result.message);
                setDatos({ 
                    Marca:'', 
                    Modelo:'', 
                    Tipo:'', 
                    IP:'192.168', 
                    Usuario:'admin', 
                    Password:'',
                    isLocal:false,
                    Frecuencia:'',
                    SSID:'',
                    KEY:'',
                    Zona:'',
                    Puerto:''
                });
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setProcessing(false);
            }
        });   
    };
    
    const handleAlert = ()=>{
        if(!isProcessing){
            setOpenDialog(true);
            setProcessing(true);
        }
    };

    const handleAlertClose = ()=>{
        setOpenDialog(false);
        setProcessing(false);
    };

    const handleSelectMarca = (value)=>{
        setDatos({...Datos, Marca:value.toString().trim()});
        setDisableTipo(false);
    };

    const handleClearMarca = ()=>{
        setDatos({...Datos, Marca:'', Tipo:'', Modelo:''});
        setDisableTipo(true);
        setDisableModelo(true);
        setModelos(ModelosList);
    };

    const handleSelectTipo = (value)=>{
        const arrF = ModelosList.filter(value2=> value2.Tipo === value );
        const arrF2 = arrF.filter(value2=>value2.Marca === Datos.Marca );
        setModelos(arrF2);
        setDatos({...Datos, Tipo:value.toString().trim()});
        setDisableModelo(false);
    };

    const handleClearTipo = ()=>{
        setDatos({...Datos, Tipo:'', Modelo:''});
        setDisableModelo(true);
        setModelos(ModelosList);
    };

    const handleClearZona = ()=>{
        setDatos({...Datos, Zona:''})
        setSelectedZona(false);
    };

    const handleSelectZona = (valZ)=>{
        setDatos({...Datos, Zona:valZ})
        setSelectedZona(true);
    }; 

    const handleSelectModelo = (value)=>{ setDatos({...Datos, Modelo:value.toString().trim()});};

    const handleClearModelo = ()=>{setDatos({...Datos, Modelo:''});};

    const handleSwitchLocal = ({target})=>{ setDatos({...Datos, isLocal:target.checked}) };

    return(
        <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={3} style={{ alignContent:'flex-start', padding:10}}>
                <Dialog
                    open={openDialog}
                    onClose={handleAlertClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Desea Guardar este Equipo"} </DialogTitle>
                    <DialogActions style={{display:'flex', justifyContent:'center'}}>
                    <Button onClick={handleValidacion1} color="primary" variant='contained' style={{color:'#fff'}}>
                        Si
                    </Button>
                    <Button onClick={handleAlertClose} color="default" variant='contained' style={{color:'#fff'}}>
                        No
                    </Button>
                    </DialogActions>
                </Dialog>  
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    {isProcessing ? <LinearProgress color='secondary' /> : <div style={{height:4}}></div>}
                </Grid>     
                <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
                    <Autocomplete
                        id="Zona"
                        options={dataZona.map(value=>value.Zona)}
                        value={Datos.Zona || ''}                              
                        renderInput={(params) => <TextField {...params} label="Zona" variant="outlined" size='small' fullWidth color='primary'/>}
                        onChange={(e,value, reason)=>{
                            if(reason ===  'clear'){
                                handleClearZona()
                            }else{
                                handleSelectZona(value);
                            }
                        }}  
                    />
                </Grid>
                <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
                    <Autocomplete
                        id="Marca"
                        options={Marcas.map(value=>value.Marca)}
                        value={Datos.Marca || ''}                              
                        renderInput={(params) => <TextField {...params} label="Marca" variant="outlined" size='small' fullWidth />}
                        onChange={(e,value, reason)=>{
                            if(reason ===  'clear'){
                                handleClearMarca()
                            }else{
                                handleSelectMarca(value);
                            }
                        }}  
                    />
                </Grid>                
                <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
                    <Autocomplete
                        id="Tipo"
                        options={Tipos.map(value=>value.Tipo)}
                        disabled={isDisableTipo}
                        value={Datos.Tipo || ''}                              
                        renderInput={(params) => <TextField {...params} label="Tipo" variant="outlined" size='small' fullWidth />}
                        onChange={(e,value, reason)=>{
                            if(reason ===  'clear'){
                                handleClearTipo()
                            }else{
                                handleSelectTipo(value);
                            }
                        }}  
                    />
                </Grid>   
                <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
                    <Autocomplete
                        id="Modelo"
                        options={Modelos.map(value=>value.Modelo)}
                        disabled={isDisableModelo}
                        value={Datos.Modelo || ''}                              
                        renderInput={(params) => <TextField {...params} label="Modelo" variant="outlined" size='small' fullWidth />}
                        onChange={(e,value, reason)=>{
                            if(reason ===  'clear'){
                                handleClearModelo()
                            }else{
                                handleSelectModelo(value);
                            }
                        }}  
                    />
                </Grid>   
                <Grid item xl={2} lg={2} md={4} sm={6} xs={12}>
                    <TextField
                        value={Datos.Usuario || ''}
                        name='Usuario'
                        onChange={handleDatos}
                        label='Usuario'
                        fullWidth
                        size='small'
                        variant='outlined'      
                        InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon color='primary'/>
                              </InputAdornment>
                            ),
                        }}                         
                    />
                </Grid>        
                <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
                    <TextField
                        value={Datos.Password || ''}
                        name='Password'
                        onChange={handleDatos}
                        label='Password'
                        fullWidth
                        size='small'
                        variant='outlined' 
                        InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <VpnKeyIcon color='primary' />
                              </InputAdornment>
                            ),
                        }}                              
                    />
                </Grid>       
                <Grid item xl={3} lg={3} md={4} sm={5} xs={7}>
                    <TextField
                        value={Datos.IP || ''}
                        name='IP'
                        onChange={handleDatos}
                        label='IP'
                        fullWidth
                        size='small'
                        variant='outlined'  
                        InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <HttpIcon color='primary'/>
                              </InputAdornment>
                            ),
                        }}                               
                    />
                </Grid>
                <Grid item xl={2} lg={2} md={2} sm={3} xs={5}>
                    <TextField
                        value={Datos.Puerto || ''}
                        name='Puerto'
                        onChange={handleDatos}
                        label='Puerto'
                        fullWidth
                        size='small'
                        variant='outlined' 
                        type='Number'
                        InputProps={{
                            startAdornment: (
                            <InputAdornment position="start">
                                <NatureIcon color='primary'/>
                            </InputAdornment>
                            ),
                        }}                              
                    />
                </Grid>
                <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
                    <TextField
                        value={Datos.Frecuencia || ''}
                        name='Frecuencia'
                        onChange={handleDatos}
                        label='Frecuencia'
                        fullWidth
                        size='small'
                        variant='outlined' 
                        type='Number'
                        InputProps={{
                            startAdornment: (
                            <InputAdornment position="start">
                                <SettingsInputAntennaIcon color='primary'/>
                            </InputAdornment>
                            ),
                        }}                              
                    />
                </Grid>
                <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
                    <TextField
                        value={Datos.SSID || ''}
                        name='SSID'
                        onChange={handleDatos}
                        label='SSID'
                        fullWidth
                        size='small'
                        variant='outlined'
                        InputProps={{
                            startAdornment: (
                            <InputAdornment position="start">
                                <CompassCalibrationIcon color='primary'/>
                            </InputAdornment>
                            ),
                        }}                             
                    />
                </Grid>
                <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
                    <TextField
                        value={Datos.KEY || ''}
                        name='KEY'
                        onChange={handleDatos}
                        label='NV2_KEY'
                        fullWidth
                        size='small'
                        variant='outlined'  
                        InputProps={{
                            startAdornment: (
                            <InputAdornment position="start">
                                <VpnKeyIcon color='primary'/>
                            </InputAdornment>
                            ),
                        }}                            
                    />
                </Grid>
                <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                    <TextField
                        value={Datos.Comentario || ''}
                        name='Comentario'
                        onChange={handleDatos}
                        label='Comentario'
                        fullWidth
                        size='small'
                        variant='outlined'                             
                    />
                </Grid>
                <Grid item xl={6} lg={6} md={8} sm={9} xs={12}>
                    <Grid container  alignItems="center" spacing={1} style={{width:'100%'}} justifyContent='center'>
                        <Grid item>OFF</Grid>
                        <Grid item>
                            <Switch checked={Datos.isLocal || false} onChange={handleSwitchLocal} name="isLocal" color='primary'/>
                        </Grid>
                        <Grid item>ON</Grid>
                        <Grid item>
                            <Alert severity={Datos.isLocal ? 'success' : 'info'}>                          
                                    Esta Antena esta conectada directamente a su CCR O RB?
                            </Alert>
                        </Grid>
                    </Grid>            
                </Grid>
                <Grid item xl={4} lg={4} md={4} sm={3} xs={12}>
                    <Button onClick={handleAlert} variant='contained'  fullWidth color='primary' size='large'  disabled={!isSelectedZona} endIcon={<DoneIcon />}>
                        {isProcessing ? <FacebookCircularProgress size={12} style={{marginTop:5}}/> : 'Procesar'}
                    </Button>
                </Grid>                       
        </Grid>
    );
};


const RegistrarEquipos= ({data, handleProcess, handleUpdate, dataZona, ModelosList, Marcas, Tipos})=>{
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
          <RegistrarEquipo data={data} handleProcess={handleProcess} handleUpdate={handleUpdate} dataZona={dataZona} Tipos={Tipos} Marcas={Marcas} ModelosList={ModelosList}/>
        </SnackbarProvider>
    );
};

export default RegistrarEquipos;